<div class="academy-film" [attr.aria-label]="label" role="group">
  <div class="academy-film__frame" [style.height.px]="height || 180">
    <div
      #stage
      class="academy-film__stage"
      [style.transform]="'scale(' + scale + ')'"
      aria-hidden="true"
    ></div>

    <button
      *ngIf="ended"
      type="button"
      class="academy-film__replay"
      (click)="restart(true)"
      [attr.aria-label]="'academy.film.replay' | translate"
    >
      <nb-icon icon="refresh-outline"></nb-icon>
      {{ 'academy.film.replay' | translate }}
    </button>
  </div>

  <!-- Untertitel der Szene unter dem Bild — im Bild deckte er Inhalte ab. -->
  <p class="academy-film__caption" aria-live="polite">{{ caption }}</p>

  <div class="academy-film__controls">
    <button
      *ngIf="!reducedMotion"
      type="button"
      class="al-icon-button"
      (click)="toggle()"
      [attr.aria-label]="(playing ? 'academy.film.pause' : 'academy.film.play') | translate"
      [nbTooltip]="(playing ? 'academy.film.pause' : 'academy.film.play') | translate"
    >
      <nb-icon [icon]="playing ? 'pause-circle-outline' : ended ? 'refresh-outline' : 'play-circle-outline'"></nb-icon>
    </button>
    <!-- Szenenmarken: Breite nach Dauer, Klick springt zur Szene. -->
    <div class="academy-film__marks" *ngIf="durations.length > 1" role="tablist" [attr.aria-label]="'academy.film.scenes' | translate">
      <button
        *ngFor="let d of durations; let i = index; trackBy: trackScene"
        type="button"
        role="tab"
        class="academy-film__mark"
        [style.flex-grow]="d"
        [attr.aria-selected]="i === index"
        [attr.aria-label]="'academy.film.scene' | translate: { n: i + 1, total: durations.length }"
        (click)="jump(i)"
      >
        <span class="academy-film__mark-fill"></span>
      </button>
    </div>
    <span class="academy-film__count" *ngIf="durations.length > 1">{{ index + 1 }} / {{ durations.length }}</span>
    <span class="academy-film__preview" *ngIf="durations.length === 1">{{ 'academy.film.preview' | translate }}</span>
  </div>
</div>
